/*
 * repairData.ts — 修理データの型定義と読み込みユーティリティ
 */

export interface ToolItem {
  id: string;
  name: string;
}

export interface PartItem {
  id: string;
  name: string;
}

export type Difficulty = "低" | "中" | "高";

export interface RepairInfo {
  difficulty: Difficulty;
  tools: ToolItem[];
  parts: PartItem[];
  notes: string[];
}

export type RepairDatabase = Record<string, RepairInfo>;

export const DIFFICULTY_CONFIG: Record<Difficulty, { label: string; color: string; bg: string; border: string; dot: string }> = {
  低: {
    label: "低",
    color: "text-emerald-400",
    bg: "bg-emerald-500/10",
    border: "border-emerald-500/30",
    dot: "bg-emerald-400",
  },
  中: {
    label: "中",
    color: "text-amber-400",
    bg: "bg-amber-500/10",
    border: "border-amber-500/30",
    dot: "bg-amber-400",
  },
  高: {
    label: "高",
    color: "text-red-400",
    bg: "bg-red-500/10",
    border: "border-red-500/30",
    dot: "bg-red-400",
  },
};

export const DIFFICULTY_DESC: Record<Difficulty, string> = {
  低: "一般ユーザーでも挑戦可能。基本的な工具と注意深い作業で対応できます。",
  中: "経験者向け。適切な工具と修理手順の理解が必要です。",
  高: "専門技術者向け。高度な技術・専用工具・防水処理の知識が必要です。",
};
